import { getTreeIndex } from "routes/schedule/lib/getTreeIndex"

export function find(item) {
    const finder = getTreeIndex().retrieve
    return finder?.(item)
}
